import React from 'react';
const SHOWROOM = 'https://autowallis.si/wp-content/uploads/2026/01/BMW-AutoWallis-LJ-2025-Foto_Ziga_Intihar-195-1500x1500.jpg';
export function AboutSection() {
  return <section className="relative w-full overflow-hidden bg-aw-navy-dark" aria-labelledby="about-title" data-id="element-10" data-mp="2gd3jj6qywhr4">
      <img src={SHOWROOM} alt="Salon AutoWallis" className="absolute inset-0 h-full w-full object-cover" data-id="element-11" data-mp="2be94mfw4fdca" />
      <div className="absolute inset-0 bg-aw-navy-dark/85" data-id="element-12" data-mp="27dgrhbk4ooaq" />

      <div className="relative mx-auto w-full max-w-[900px] px-5 py-24 text-center lg:px-10" data-id="element-13" data-mp="22lyueyl877v1">
        <h2 id="about-title" className="font-heading text-3xl font-bold text-white sm:text-4xl" data-id="element-14" data-mp="1xmlylocdmqgb">
          O Skupini AutoWallis
        </h2>
        <div className="mt-8 space-y-5 text-sm leading-relaxed text-white/75" data-id="element-15" data-mp="1sou4qos68u9h">
          <p data-id="element-16" data-mp="1noo8swevclll">
            AutoWallis je vodilni integrirani ponudnik avtomobilske maloprodaje in mobilnostnih
            storitev v regiji Srednje in Vzhodne Evrope, ki posluje v 17 državah in zastopa 30
            blagovnih znamk.
          </p>
          <p data-id="element-17" data-mp="spzsu02utwsm">
            V Sloveniji je prisoten od leta 2007 kot ekskluzivni uvoznik vozil in nadomestnih delov
            znamke Saab. Veleprodajne dejavnosti so se leta 2016 razširile z distribucijo vozil
            znamk Jaguar in Land Rover, leta 2020 pa še z znamko Opel. Maloprodajna divizija danes
            prodaja in servisira vozila znamk BMW, MINI, Land Rover, Opel, Toyota, Suzuki in XPENG
            v petih mestih po Sloveniji.
          </p>
          <p data-id="element-18" data-mp="1ggm2twwf5r59">
            AutoWallis je zavezan zagotavljanju svobode vožnje svojim strankam kot dolgoročni
            partner z vrhunskimi blagovnimi znamkami in rešitvami v avtomobilski industriji.
          </p>
        </div>
        <a href="#" className="mt-10 inline-block bg-aw-accent px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-aw-navy" data-id="element-19" data-mp="16ho4y3d3sl9l">
          Ekipa AutoWallis v Sloveniji
        </a>
      </div>
    </section>;
}